import Vue from 'vue'
import VueResource from 'vue-resource'
import Vuex from 'vuex'

Vue.use(VueResource)
Vue.use(Vuex)

// v-resize
Vue.directive('resize', {
  inserted: function (el, binding) {
    const resizeObserver = new ResizeObserver(entries => {
      for (let entry of entries) {
        binding.value(entry)
      }
    });

    // v-resize.border
    const boxModel = binding.modifiers.border ? 'border-box' : 'content-box'

    resizeObserver.observe(el, { box: boxModel });
  },
  unbind: function (el) {
    resizeObserver.disconnect(el);
  }
})

Vue.http.interceptors.push(function(request, next) {
  const token = $('[name="csrf-token"]').attr('content')
  request.headers.set('X-CSRF-TOKEN', token)
  next()
})

export default Vue



// WEBPACK FOOTER //
// ./app/javascript/lib/vue.js